import { Button, ListItemIcon, MenuItem } from "@mui/material";
import MergeTypeRoundedIcon from "@mui/icons-material/MergeTypeRounded";
import { useState } from "react";
import { createPortal } from "react-dom";
import {
  useActionsMenuContext,
  type SummaryContext,
} from "../../shared/ActionsMenuContext";
import { toast } from "../../../../utils/snackbarHelper";
import { toastMessage } from "../../../../constants/strings";
import { labelButtonStyle } from "../../../../components/shared/PopupMenu";
import type { ValidateMergeRequestResult } from "../../../../hooks/useValidateMergeRequest";
import type { PlanTableFormat } from "../../../../types/planning/plan.type";
import { useMergeValidation } from "../../../../hooks/useMergeValidation";
import MergeRoutesTrapsErrorDialog from "../MergeRoutesTrapsErrorDialog";

interface MergeMenuItemProps {
  clearSelection?: () => void;
  shipmentContext: SummaryContext[];
  planSummaries: PlanTableFormat[];
  validateMergeRequest: () => ValidateMergeRequestResult;
}

const MergeMenuItem = ({
  clearSelection = () => {},
  shipmentContext,
  planSummaries,
  validateMergeRequest,
}: MergeMenuItemProps) => {
  const { openDialog } = useActionsMenuContext();
  const [isMergeRoutesTrapsDialogOpen, setIsMergeRoutesTrapsDialogOpen] =
    useState<boolean>(false);
  const [errorGroups, setErrorGroups] = useState<
    { message: string; plans: PlanTableFormat[] }[]
  >([]);

  const { validateMerge } = useMergeValidation(
    planSummaries,
    validateMergeRequest
  );

  const handleMergeClick = () => {
    const warningMessage = validateMergeRequest();
    if (warningMessage) {
      toast(toastMessage.inbound.mergeRoutesAndTraps[warningMessage], {
        variant: "warning",
      });
      return;
    }

    const validationErrors = validateMerge();
    if (validationErrors.length > 0) {
      setErrorGroups(validationErrors);
      setIsMergeRoutesTrapsDialogOpen(true);
      return;
    }

    openDialog({
      name: "merge-routes-traps",
      shipmentContext,
      clearSelection,
      planSummaries,
    });
  };

  return (
    <>
      <MenuItem onClick={handleMergeClick}>
        <ListItemIcon>
          <MergeTypeRoundedIcon />
        </ListItemIcon>
        <Button sx={labelButtonStyle} disableRipple>
          Merge
        </Button>
      </MenuItem>
      {isMergeRoutesTrapsDialogOpen &&
        createPortal(
          <MergeRoutesTrapsErrorDialog
            open={isMergeRoutesTrapsDialogOpen}
            onClose={() => setIsMergeRoutesTrapsDialogOpen(false)}
            errorGroups={errorGroups}
          />,
          document.body
        )}
    </>
  );
};

export default MergeMenuItem;
